export default __webpack_public_path__ + "static/media/office1-before1-2048w.87ac2087.webp";